import emailCheck from './lib/EmailCheck';

const NewsletterSubmitInit = (form: HTMLFormElement) => {
  const privacy = form.querySelector('input[name=privacy]') as HTMLInputElement;
  const button = form.querySelector('button');
  privacy.addEventListener('change', () => {
    if (privacy.checked) {
      button.removeAttribute('disabled');
    } else {
      button.setAttribute('disabled', 'true');
    }
  });
  form.addEventListener('submit', (event: SubmitEvent) => {
    event.preventDefault();
    const email = form.querySelector('form.newsletter-form input.form__input') as HTMLInputElement;

    if (!email) {
      return;
    }

    const body = form.querySelector('.form__inner') as HTMLInputElement;
    const success = form.querySelector('.success') as HTMLInputElement;
    const fail = form.querySelector('.fail') as HTMLInputElement;
    const listId = form.dataset.id;

    if (emailCheck(email.value)) {
      fetch(`/wp-json/mailcamp/v1/add_subscriber?email=${encodeURIComponent(email.value)}&list=${listId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((response): void => {
          body?.remove();
          if (response) {
            success.classList.add('form__notice--active');
          } else {
            fail.classList.add('form__notice--active');
          }
        })
        .catch(() => {
          fail.classList.add('form__notice--active');
        });
    } else {
      email.classList.add('error');
    }
  });
};

export default NewsletterSubmitInit;
